import { InitialState } from "./type";

export const initialState: InitialState = {
  userList: {},
  token: "",
  logout: false,
};
